/**
 * Location search directive
 */
.input-location a {
  // Because Bootstrap-typeahead links need this
  cursor: pointer;
}
